import './polyfills.ts';
import { NgZone } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { UIRouter, UrlService } from '@uirouter/core';

import { AppModule } from './app/app.module';
import { AppInitService } from './app/core/services/app-init.service';

// Links already emailed to users use the AngularJS-era hash form (/#/authenticateToken?...).
if (window.location.hash.indexOf('#/') === 0) {
  window.history.replaceState(null, '', window.location.hash.substring(1));
}

platformBrowserDynamic().bootstrapModule(AppModule).then((platformRef) => {
  const router: UIRouter = platformRef.injector.get(UIRouter);
  const urlService: UrlService = router.urlService;

  function startUIRouter() {
    urlService.listen();
    platformRef.injector.get(AppInitService).startRouter(router);
  }

  platformRef.injector.get<NgZone>(NgZone).run(startUIRouter);
});
